import React from "react";
import { useDispatch } from "react-redux";
import { changeOptionSidePanel, sidePanelOption } from "../slices/optionsSlice";
import { ReactComponent as TickSquareIcon } from "../assets/tick-square.svg";
import { ReactComponent as InfoArrowIcon } from "../assets/info_arrow.svg";
import { DESCRIPTION_TYPE } from "./Constants";
import { useHistory, useLocation } from 'react-router-dom'

const GoalCard = ({children, text, url, selected = false, select, unselect, id, stub}) => {
    const dispatch = useDispatch();
    const [isChecked, setChecked] = React.useState(selected);
    const history = useHistory();
    const location = useLocation();
   
    React.useEffect(() => {
        if (selected !== undefined) {
            setChecked(selected)
        }
    }, [selected])

    React.useEffect(() => {
        if(location.pathname.substring(1) === stub){
            dispatch(changeOptionSidePanel(sidePanelOption(true, DESCRIPTION_TYPE, text)));
        }
    }, [])

    const textStyled = React.useMemo(() => {
        let ar = text.split(" ");
        let firstWord = ar[0]+" ";

        return <p className={stub}><b>{firstWord}</b> {ar.slice(1, ar.length).join(" ")}</p>;
    }, [text])

    const moreInfoHandler = () => {
        distil.trackEvent('goal_more_info', ' ', {goal_id: id});
        dispatch(changeOptionSidePanel(sidePanelOption(true, DESCRIPTION_TYPE, text, 0, stub)));
        history.push('/' + stub);
    }

    return <div className="goal-card" onClick={moreInfoHandler}>
            <div>
                <div className="goal-card-text" >
                    {textStyled}
                </div>
                <div className="goal-card-check" >
                    <TickSquareIcon onClick={(e) => {
                        e.stopPropagation();
                        setChecked(!isChecked);
                        distil.trackEvent('goal_check_changed', ' ', {goal_id: id, value: !isChecked});
                        if (isChecked) {
                            unselect(id);
                        } else {
                            select(id);
                        }
                    }} fill={isChecked ? "#9FCE1D" : "#EAEAEA"}/>
                </div>
            </div>
            <p className="goal-card-button">
                Tell me more <InfoArrowIcon/>
            </p>  
            {children}
        </div>
};

export default GoalCard;
